// ヘッダーに関する処理
// 本国jQueryをもとにJavaScriptに置き換え
function globalHeader() {
    // 変数宣言（冗長だが移植元から引き継ぎ）
    const body = document.body,
        header = document.querySelector(".js-header"),
        navToggle = document.querySelector(".js-nav-toggle"),
        navigationInner = document.querySelector(".js-navigation-inner"),
        navMobile = document.querySelector(".js-nav-mobile"),
        mobileFlyin = navMobile.querySelectorAll(".js-mobile-flyin"),
        mobileNavNextLvl = navMobile.querySelectorAll(".js-mobile-nav-next-lvl"),
        classNameMobileLayer = ".js-nav-mobile-layer",
        classNameMobileAdditional = ".js-nav-mobile-additional",
        headerActions = document.querySelector(".js-header-actions"),
        headerLogo = document.querySelector(".js-header-logo"),
        navDesktop = document.querySelector(".js-nav-desktop"),
        navDesktopItemLink = document.querySelectorAll(".js-nav-desktop-item-link"),
        navDesktopSubLink = document.querySelectorAll(".js-nav-desktop-sublink"),
        navDesktopLayer = document.querySelectorAll(".js-nav-desktop-layer"),
        navLayerBack = document.querySelectorAll(".js-nav-layer-back"),
        navMobileSublink = navDesktop.querySelectorAll(".js-nav-mobile-sublink"),
        searchInputToggle = document.querySelector('.js-search-input-toggle'),
        closeSearchBar = document.querySelector('.js-close-search-bar'),
        searchInput = document.querySelector('.js-search-input-field'),
        searchOverlay = document.querySelector('.js-search-overlay'),
        searchOpen = document.querySelector('.js-search-open'),
        classNameDesktopLayer = ".js-nav-desktop-layer",
        classNameDesktopOverlay = ".js-nav-desktop-overlay",
        classNameCloseDesktopNav = ".js-close-desktop-nav",
        classNameCloseDesktopSubnav = ".js-close-desktop-subnav",
        classNameNavFirstLayer = ".js-nav-first-layer",
        classNameMobScrollableContainer = ".js-mob-scrollable-container",
        classNameDesktopScrollableContainer = ".js-nav-first-layer > .js-desktop-scrollable-container",
        classNameDesktopScrollableSubcontainer = ".js-desktop-scrollable-subcontainer",
        classNameScrollableParent = ".js-scrollable-parent",
        classNameNavDesktopSecondLayer = ".js-nav-desktop-second-layer",
        classNameNavMobileSublink = ".js-nav-mobile-sublink";

    let headerStopFlag = false;

    // jQueryのfadeを再現
    function fadeIn(element, duration, callback) {
        let opacity = 0;
        duration = duration / 100;
        element.style.opacity = opacity;
        element.style.display = "block";
        var fadeInInterval = setInterval(function () {
            if (opacity < 1) {
                opacity += 0.1;
                element.style.opacity = opacity;
            } else {
                clearInterval(fadeInInterval);
                if (callback) {
                    callback();
                }
            }
        }, duration);
    }
    function fadeOut(element, duration = 500, callback) {
        element.style.transition = `opacity ${duration / 1000}s ease`;
        element.style.opacity = 0;
        setTimeout(() => {
            element.style.display = 'none';
            element.style.opacity = null;
        }, duration);
        if (callback) {
            callback();
        }
    }

    // SP版グロナビヘッダー開閉：移植元function Q()
    function mobileHeaderToggle() {

        function headerFlagChange(flag) {
            headerStopFlag = flag;
        }
        function headerFlagChangeGradient(flag) {
            headerStopFlag = flag;
            gradientToggle(classNameMobileLayer, classNameMobScrollableContainer)
        }
        function delayGradientToggle() {
            setTimeout(() => {
                gradientToggle(classNameMobileLayer, classNameMobScrollableContainer)
            }, 100);
        }

        // 関数宣言
        navToggle.addEventListener("click", function () {
            if (navToggle.classList.contains("active")) {
                // イベントリスナーを解除し、ナビゲーションを閉じる
                body.style.overflow = "";
                body.removeEventListener("touchstart", headerFlagChange);
                body.removeEventListener("touchmove", headerFlagChange);
                body.removeEventListener("touchend", headerFlagChangeGradient);
                searchOpen.style.display = "block"; // 検索フォームの展開ボタン
                searchInputToggle.style.display = "none"; // 検索ボタン
                navMobile.querySelectorAll(classNameMobScrollableContainer).forEach(function (el) {
                    el.removeEventListener("scroll", delayGradientToggle);
                });
                mobileNavigationClose();
            } else {
                // イベントリスナーの追加
                body.style.overflow = "hidden";
                body.addEventListener("touchstart", headerFlagChange(false));
                body.addEventListener("touchmove", headerFlagChange(true));
                body.addEventListener("touchend", headerFlagChangeGradient(false));
                navMobile.querySelectorAll(classNameMobScrollableContainer).forEach(function (el) {
                    el.addEventListener("scroll", delayGradientToggle);
                });

                // ナビゲーションを開く
                header.classList.add("nav-active");
                navToggle.classList.add("active");
                navigationInner.classList.add("active");
                fadeIn(navMobile, 200);
                navMobile.setAttribute("aria-hidden", "false");
                searchOpen.style.display = "none"; // 検索フォームの展開ボタン
                searchInputToggle.style.display = "block"; // 検索ボタン

                if (window.innerWidth < 768) {
                    headerActions.classList.add("search-expand");
                }

                headerLogo.setAttribute("tabindex", "-1");

                mobileFlyin.forEach(function (element, index) {
                    setTimeout(function () {
                        element.parentElement.classList.add("flyin");
                    }, 40 * index);
                });
            }
        });

        document.addEventListener("keydown", function (el) {
            // .keycodeも.whichも非推奨だが、移植元からひとまず残す
            // Escキーが押された場合のモーダルを閉じる処理
            if (el.which === 27 && navToggle.classList.contains("active")) {
                mobileNavigationClose();
            }
        });

    }

    // 検索
    // 検索窓の開閉関数を定義
    // 検索窓を開く：移植元 function B()
    function openSearchArea() {
        body.style.overflow = "hidden";
        navDesktop.classList.add("fade-nav");
        headerActions.classList.add("search-expand");
        headerLogo.classList.add("fade-out");
        navToggle.classList.add("fade-out");
        closeSearchBar.style.display = "inline-block";
        searchOverlay.style.display = "block";
        searchOverlay.style.top = header.offsetHeight + "px";
        searchOverlay.style.opacity = 0.5;
        searchOpen.style.display = "none";
        searchInputToggle.style.display = "";
    }
    // 検索窓を閉じる：移植元 function x()
    function closeSearchArea() {
        body.style.overflow = null;
        navDesktop.classList.remove("fade-nav");
        headerActions.classList.remove("search-expand");
        headerLogo.classList.remove("fade-out");
        navToggle.classList.remove("fade-out");
        closeSearchBar.style.display = "none";
        searchOverlay.style.display = "none";
        searchInput.value = '';
        searchOpen.style.display = "";
        searchInputToggle.style.display = "none";
    }
    // 検索ボタン（虫眼鏡アイコン）を押した時に
    searchOpen.addEventListener('click', function () {
        // ハンバーガーメニュー展開中(nav-active)に検索ボタンを押下した時は動作しない
        if (!header.classList.contains('nav-active')) {
            openSearchArea();
        }
    });
    // 閉じるボタンを押した時
    closeSearchBar.addEventListener('click', function () {
        closeSearchArea();
    });
    // 検索窓にフォーカスが当たった時
    searchInput.addEventListener('focus', function () {
        if (!headerActions.classList.contains("search-expand")) {
            openSearchArea();
        }
    });
    // オーバーレイをクリックした時
    searchOverlay.addEventListener('click', function () {
        closeSearchArea();
    });

    // ヘッダーのナビゲーションを閉じる：移植元function j()
    function mobileNavigationClose() {
        navToggle.classList.remove("active");
        navigationInner.classList.remove("active");
        fadeOut(navMobile, 200);
        navMobile.setAttribute("aria-hidden", "true");
        headerActions.classList.remove("search-expand");
        headerLogo.removeAttribute("tabindex");
        mobileFlyin.forEach(function (element) {
            element.classList.remove("flyin");
        });
        navMobile.querySelectorAll(classNameMobileLayer).forEach(function (element) {
            element.classList.remove("visible");
            fadeOut(element);
        });
        navMobile.querySelectorAll("li").forEach(function (element) {
            element.classList.remove("flyin", "flyout");
        });
        navMobile.querySelectorAll("a, button").forEach(function (element) {
            element.removeAttribute("tabindex");
        });
        body.style.overflow = "";
        header.classList.remove("nav-active");
    }

    // 移植元：function I(e, a)
    function gradientToggle(e, a) {
        document.querySelectorAll(e).forEach(function (element) {
            var e, t, n, r, o, i;
            if (element.classList.contains("visible")) {
                e = element;
                t = e.querySelector(a);
                n = t.querySelector("ul");
                o = t.offsetTop - 5;
                r = n.offsetTop;
                i = r + n.scrollHeight;

                if (i < o) {
                    e.classList.add("top-gradient");
                } else {
                    e.classList.remove("top-gradient");
                }

                if (t.offsetTop + t.offsetHeight + 10 < i) {
                    e.classList.add("bottom-gradient");
                } else {
                    e.classList.remove("bottom-gradient");
                }
            }
        });
    }

    // 移植元：function T(e, a) ※後追い移植予定、一部未調整
    function headerStickeyBanner(e, a) {
        document.querySelectorAll(e).forEach(function (element) {
            var e = element,
                t = e.querySelector(a),
                n = t.querySelector("ul"),
                r = t.offsetTop,
                o = n.offsetTop,
                r = r + t.offsetHeight - 26,
                t = n.scrollHeight + o,
                o = e.querySelector(".js-navigation-content-banner"),
                i = o.offsetHeight;
            if (o) {
                if (t < r && e.classList.contains("visible")) {
                    e.classList.add("sticky-content-banner");
                    if (116 < i) {
                        n.style.paddingBottom = i + "px";
                    } else {
                        n.style.paddingBottom = "";
                    }
                } else if (r < t && e.classList.contains("visible")) {
                    e.classList.remove("sticky-content-banner");
                    n.style.paddingBottom = "";
                }
            }
        });
    }

    // PC版グロナビヘッダー開閉：移植元function R()
    function globalHeaderToggle() {
        navDesktopItemLink.forEach(function (item) {
            item.removeEventListener("click", handleClick);
            item.addEventListener("click", handleClick);
        });

        function handleClick() {
            let selectedFlag = false,
                selectedNavLayer = this.nextElementSibling;
            
            navDesktopItemLink.forEach(function (item) {
                if(item.classList.contains("selected")) {
                    selectedFlag = true;
                    return;
                }
            })

            // メニュー展開処理
            // ※既に展開済みのメニュー項目を選択した場合は何もしない
            if(!this.classList.contains("selected")) {
                if (!selectedFlag) { // 展開済みのメニューが他に無い場合
                    this.classList.add("selected");
                    navDesktop.classList.add("active");
                    fadeIn(selectedNavLayer.querySelector(classNameDesktopOverlay), 500);
                    body.style.overflow = "hidden";
                    fadeIn(selectedNavLayer, 500, function () {
                        selectedNavLayer.classList.add("visible");
                        setTimeout(function () {
                            selectedNavLayer.querySelectorAll(classNameNavMobileSublink).forEach(function (item, index) {
                                setTimeout(function () {
                                    item.classList.add("flyin");
                                }, 40 * index);
                            });
                            selectedNavLayer.querySelectorAll(classNameCloseDesktopNav).forEach(function (item) {
                                item.style.display = "block";
                            });
                        }, 600);
                        setTimeout(function () {
                            selectedNavLayer.classList.add("opened");
                        }, 800);
                        gradientToggle(classNameDesktopLayer, classNameDesktopScrollableContainer);
                    });
                } else { //既に展開済みのメニューがある場合
                    // 展開済みのメニューを非表示にする
                    navDesktopItemLink.forEach(function (item) {
                        item.classList.remove("selected");
                    });
                    navMobileSublink.forEach(function (item) {
                        item.classList.remove("flyin");
                    });
                    navDesktopLayer.forEach(function (item) {
                        item.style.display = "none";
                        item.classList.remove("visible", "opened");
                        item.querySelectorAll(classNameCloseDesktopNav).forEach(function (item) {
                            item.style.display = "none";
                        });
                        item.querySelectorAll(classNameDesktopOverlay).forEach(function (item) {
                            item.style.display = "none";
                        });
                    }); 

                    // 改めて該当メニューを表示する
                    this.classList.add("selected");
                    selectedNavLayer.style.display = "block";
                    selectedNavLayer.classList.add("visible", "opened");
                    selectedNavLayer.querySelectorAll(classNameCloseDesktopNav).forEach(function (item) {
                        item.style.display = "block";
                    });
                    selectedNavLayer.querySelectorAll(classNameDesktopOverlay).forEach(function (item) {
                        item.style.display = "block";
                    });

                    setTimeout(function () {
                        selectedNavLayer.querySelectorAll(classNameNavMobileSublink).forEach(function (item, index) {
                            setTimeout(function () {
                                item.classList.add("flyin");
                            }, 40 * index);
                        });
                    }, 400);
    
                    gradientToggle(classNameDesktopLayer, classNameDesktopScrollableContainer);
    
                    // 第三階層メニューが開いていたら閉じる
                    navDesktop.querySelectorAll(classNameNavDesktopSecondLayer).forEach(function (item) {
                        let secondLayer = item,
                            itemScrollableParent = secondLayer.querySelector(classNameScrollableParent),
                            itemCloseDesktopSubnav = secondLayer.querySelector(classNameCloseDesktopSubnav),
                            itemFlyin = secondLayer.querySelectorAll(".js-nav-desktop-sublink-flyin");

                        if (secondLayer.classList.contains("opened")) {
                            secondLayer.style.display = "none";
                            navDesktop.querySelectorAll(classNameNavFirstLayer).forEach(
                                function( firstLayer ) {
                                    firstLayer.classList.remove("first-opening")
                                }
                            );
                            secondLayer.classList.remove("slide-in", "opend", "visible");
                            itemScrollableParent && itemScrollableParent.classList.remove("visible");
                            itemCloseDesktopSubnav && (itemCloseDesktopSubnav.style.display = "none");
                            secondLayer.querySelectorAll(classNameNavMobileSublink).forEach(function (sublink) {
                                sublink.classList.remove("active");
                            });
                            itemFlyin && itemFlyin.forEach(function (flyin) {
                                flyin.classList.remove("flyin");
                            });
                        }
                    });
                }

            }
        }

    }

    // PC版第三階層ドロワー表示：移植元function P(e)
    function openThirdLayer(sublink) {
        if (sublink.classList.contains("active")) {
            return;
        }
        let siblingsSubNavItem = sublink.closest("ul").querySelectorAll(":scope > .js-nav-mobile-subnav-item"), // = t
            selectedSecondLayer = sublink.parentElement.querySelector(classNameNavDesktopSecondLayer), // = n.siblings(S)
            activeSublink = sublink.closest(".nav-first-layer").querySelectorAll(".js-nav-desktop-sublink.active")

        // 選択項目に第三階層メニューがある場合
        if(selectedSecondLayer) {
            selectedSecondLayer.querySelector(classNameScrollableParent).classList.add("visible");

            // mouseenter要素の兄弟要素に対する処理　
            siblingsSubNavItem.forEach(function (subnavItem) {
                let item = subnavItem.querySelector(".js-nav-desktop-sublink"),
                    itemSecondLayer = item.parentElement.querySelector(classNameNavDesktopSecondLayer),
                    itemScrollableParent = item.parentElement.querySelector(classNameScrollableParent),
                    itemCloseDesktopSubnav = item.parentElement.querySelector(classNameCloseDesktopSubnav),
                    itemFlyin = item.parentElement.querySelectorAll(".js-nav-desktop-sublink-flyin");
                // 展開済み項目の有無判定
                if ( item === sublink ) {
                    
                } else if ( activeSublink.length > 0 ) {
                    // 既に展開済みの第三階層メニューがある場合
                    item.closest(classNameNavFirstLayer).classList.remove("first-opening");
                    item.classList.remove("active");
                    itemSecondLayer && (itemSecondLayer.style.display = "none",itemSecondLayer.classList.remove("slide-in", "opened", "visible"));
                    itemScrollableParent && itemScrollableParent.classList.remove("visible");
                    itemCloseDesktopSubnav && (itemCloseDesktopSubnav.style.display = "none");
                    itemFlyin && itemFlyin.forEach(function (flyin) {
                        flyin.classList.remove("flyin");
                    });

                    // 該当項目の第三階層メニューを表示する
                    selectedSecondLayer.style.display = "block";
                    selectedSecondLayer.classList.add("visible", "opened");
                    selectedSecondLayer.querySelector(classNameCloseDesktopSubnav).style.display = "block";
                    gradientToggle(classNameScrollableParent, classNameDesktopScrollableSubcontainer);
                    //headerStickeyBanner(classNameScrollableParent, classNameDesktopScrollableSubcontainer); 後追い実装のため一時的にコメントアウト
                    setTimeout(function () {
                        selectedSecondLayer.querySelectorAll(".js-nav-desktop-sublink-flyin").forEach(function (item, index) {
                            setTimeout(function () {
                                item.classList.add("flyin");
                            }, 40 * index);
                        });
                    }, 100);
                } else {
                    // 既に展開済みの第三階層メニューがない場合
                    sublink.closest(classNameNavFirstLayer).classList.add("first-opening");
                    fadeIn(selectedSecondLayer, 100, function () {
                        selectedSecondLayer.classList.add("slide-in");
                        setTimeout(function () {
                            fadeIn(selectedSecondLayer.querySelector(classNameCloseDesktopSubnav), 300),
                            selectedSecondLayer.classList.add("opened");
                            selectedSecondLayer.querySelectorAll(".js-nav-desktop-sublink-flyin").forEach(function (item, index) {
                                setTimeout(function () {
                                    item.classList.add("flyin");
                                }, 40 * index);
                            });
                        }, 1000);
                        gradientToggle(classNameScrollableParent, classNameDesktopScrollableSubcontainer);
                        //headerStickeyBanner(classNameScrollableParent, classNameDesktopScrollableSubcontainer);　後追い実装のため一時的にコメントアウト
                    });          
                }
            })
            sublink.classList.add("active");
        } else {
            if( activeSublink.length > 0 ) {
                fadeIn(sublink.closest(classNameNavFirstLayer).querySelector(classNameCloseDesktopNav), 300);
                sublink.closest(classNameNavFirstLayer).classList.remove("first-opening");
                siblingsSubNavItem.forEach(function (subnavItem) {
                    let item = subnavItem.querySelector(".js-nav-desktop-sublink"),
                        itemSecondLayer = item.parentElement.querySelector(classNameNavDesktopSecondLayer),
                        itemScrollableParent = item.parentElement.querySelector(classNameScrollableParent),
                        itemCloseDesktopSubnav = item.parentElement.querySelector(classNameCloseDesktopSubnav),
                        itemFlyin = item.parentElement.querySelectorAll(".js-nav-desktop-sublink-flyin");

                    // 展開済み項目の有無判定
                    if ( item !== sublink ) {
                        item.classList.remove("active");
                        itemSecondLayer && ( itemSecondLayer.style.display = "none",
                        itemSecondLayer.classList.remove("slide-in", "opened", "visible"));
                        itemScrollableParent && itemScrollableParent.classList.remove("visible");
                        itemCloseDesktopSubnav && (itemCloseDesktopSubnav.style.display = "none");
                        itemFlyin && itemFlyin.forEach(function (flyin) {
                            flyin.classList.remove("flyin");
                        });
                    }
                })
                
            }
        }
    }

    // グロナビドロワーのエスケープ処理：移植元function H()
    function HeaderDrawerEscape() {
        document.querySelectorAll(classNameCloseDesktopNav).forEach(function (item) {
            item.addEventListener("click", function () {
                HeaderDrawerClose();
            });
        });
        navDesktop.querySelectorAll(classNameCloseDesktopSubnav).forEach(function (item) {
            let firstLayer = item.closest(classNameNavFirstLayer),
                secondLayer = item.closest(classNameNavDesktopSecondLayer);
            item.addEventListener("click", function () {
                firstLayer.classList.add("first-opening");
                item.style.display = "none";
                item.closest(classNameScrollableParent).classList.remove("visible");
                secondLayer.classList.remove("slide-in", "visible");
                firstLayer.querySelectorAll(classNameNavMobileSublink).forEach(function (sublink) {
                    sublink.classList.remove("active");
                });
                secondLayer.querySelectorAll(".js-nav-desktop-sublink-flyin").forEach(function (flyin) {
                    flyin.classList.remove("flyin");
                });
                firstLayer.querySelectorAll(classNameNavMobileSublink).forEach(function (sublink) {
                    sublink.classList.add("disabled");
                })
                setTimeout(function () {
                    fadeIn(firstLayer.querySelector(classNameCloseDesktopNav), 400)
                }, 200);
                setTimeout(function () {
                    secondLayer.style.display = "none";
                    item.closest(".js-desktop-nav-item").querySelectorAll(classNameNavDesktopSecondLayer).forEach(function (item) {
                        item.classList.remove("opened");
                    });
                    firstLayer.classList.remove("first-opening");
                    firstLayer.querySelectorAll(classNameNavMobileSublink).forEach(function (sublink) {
                        sublink.classList.remove("disabled");
                    })
                }, 1000);
            });
        });
        document.addEventListener("keydown", function (el) {
            // .keycodeも.whichも非推奨だが、移植元からひとまず残す
            // Escキーが押された場合のモーダルを閉じる処理
            if (el.which === 27 && navDesktop.classList.contains("active")) {
                HeaderDrawerClose();
            }
        });
    }

    // グロナビドロワーの閉じる処理：移植元function O()
    function HeaderDrawerClose() {
        document.querySelectorAll(classNameDesktopOverlay).forEach(function (item) {
            fadeOut(item);
        })
        navDesktopItemLink.forEach(function (item) {
            item.classList.remove("selected");
            item.classList.add("disabled");
        });
        document.querySelectorAll(classNameCloseDesktopNav).forEach(function (item) {
            item.style.display = "none";
        });
        navDesktopLayer.forEach(function (item) {
            item.classList.remove("visible");
        });
        navDesktop.classList.remove("active");
        body.style.overflow = "visible";
        document.querySelectorAll(classNameNavDesktopSecondLayer).forEach(function (item) {
            if (item.classList.contains("opened") ) {
                item.closest(classNameNavFirstLayer).classList.add("first-opening");
                item.classList.remove("slide-in", "opened", "visible");
                item.querySelector(classNameScrollableParent).classList.remove("visible");
                item.querySelector(classNameCloseDesktopSubnav).style.display = "none";
                item.parentElement.querySelectorAll(classNameNavMobileSublink).forEach(function (sublink) {
                    sublink.classList.remove("active");
                });
            }
        });
        setTimeout(function () {
            navMobileSublink.forEach(function (item) {
                item.classList.remove("flyin");
            });
            navDesktopLayer.forEach(function (item) {
                fadeOut(item);
                navDesktopItemLink.forEach(function (item) {
                    item.classList.remove("disabled");
                });
                item.classList.remove("opened");
                document.querySelectorAll(classNameNavDesktopSecondLayer).forEach(function (item) {
                    item.style.display = "none";
                    item.closest(classNameNavFirstLayer).classList.remove("first-opening");
                })

            });
        }, 1000);
    }

    // イニシャライズ関数内の無名関数を、移植にあたって外部化
    function mobileNextLevel(selectedMenuItem) {
        let menuParentItem = selectedMenuItem.parentElement, // = n = .js-nav-mobile-subnav-item ボタン直上のli要素
            menuParentSibling = menuParentItem.parentElement.querySelectorAll(":scope > li"); // = n.siblings = ボタン直上li要素の兄弟要素 自分自身は含めないように別途処理する
        if(!headerStopFlag) {
            selectedMenuItem.classList.add("js-selected-category");
            menuParentItem.classList.add("flyout");
            menuParentSibling.forEach(function (item) {
                if( item !== menuParentItem ) {
                    item.classList.add("flyout");
                    item.querySelectorAll(".js-mobile-flyin").forEach(function (subitem) {
                        subitem.setAttribute("tabindex", "-1");
                    });
                    item.querySelectorAll(classNameNavMobileSublink).forEach(function (subitem) {
                        subitem.setAttribute("tabindex", "-1");
                    });
                }
            });
            selectedMenuItem.setAttribute("tabindex", "-1");
            selectedMenuItem.closest(classNameMobScrollableContainer)?.previousElementSibling?.setAttribute("tabindex", "-1");
            navMobile.querySelectorAll(classNameMobileLayer).forEach(function (item) {
                item.classList.remove("js-visible");
            });
            
            selectedMenuItem.nextElementSibling.classList.add("visible", "js-visible"); // e.siblings(u) = selectedMenuItem.nextElementSibling = .js-nav-mobile-layer
            selectedMenuItem.nextElementSibling.setAttribute("aria-hidden", "false");
            fadeIn(selectedMenuItem.nextElementSibling, 100, function(){
                let underListItems = selectedMenuItem.nextElementSibling.querySelector("ul").querySelectorAll(":scope > li");
                selectedMenuItem.nextElementSibling.querySelector(classNameMobScrollableContainer).scrollTop = 0;
                underListItems.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.add("flyin");
                    }, 40 * index);
                });
            });

            navMobile.querySelectorAll(".js-nav-mobile-additional li").forEach(function (additionalMenuItem) {
                additionalMenuItem.classList.add("flyout");
                additionalMenuItem.querySelector("a").setAttribute("tabindex", "-1");
            });

            gradientToggle(classNameMobileLayer, classNameMobScrollableContainer);

            menuParentSibling.forEach(function (parentSibling) {

                // 自身以外の兄弟要素に処理する
                if( parentSibling !== menuParentItem ) {
                    let underLayer = parentSibling.querySelector(classNameMobileLayer);
                    //console.log(underLayer)
                    if( underLayer?.classList.contains("visible") ) {
                        underLayer.classList.remove("visible");
                        underLayer.style.display = "none";

                        underLayer.querySelectorAll(".js-nav-mobile-subnav-item").forEach(function (subNavItem) {
                            subNavItem.classList.remove("flyin", "flyout");
                        });

                        parentSibling.querySelectorAll(".js-nav-mobile-sublink, .js-nav-layer-back, .js-mobile-nav-next-lvl").forEach(function (sublink) {
                            sublink.removeAttribute("tabindex");
                        });

                    }
                }
            });
        }
    }

    function mobileLayerBack(selectedMenuItem) {
        let parentLayer = selectedMenuItem.closest(classNameMobileLayer); // = e = i.parent(u)
        parentLayer.classList.remove("js-visible");
        parentLayer.querySelector("ul")?.querySelectorAll(":scope > li")?.forEach(function (item) {
            item?.classList.remove("flyin");
        });
        parentLayer.classList.remove("visible");
        fadeOut(parentLayer, 70, function () {
            // フェードアウト後のコールバック処理
            let parentUl = selectedMenuItem.closest("ul"),
                siblingsLi = parentUl?.parentElement?.querySelectorAll(":scope > ul > li"),
                siblingAdditionalMenu = parentUl.parentElement?.querySelector(classNameMobileAdditional);

            parentUl.querySelectorAll(".js-selected-category").forEach(function (selectedCategory) {
                selectedCategory.classList.remove("js-selected-category");
            });
            parentUl.querySelectorAll(":scope > .js-nav-mobile-subnav-item > .js-nav-mobile-sublink").forEach(function (subLink) {
                subLink.removeAttribute("tabindex");
            });
            parentUl.querySelectorAll(":scope > .js-nav-mobile-subnav-item > .js-mobile-nav-next-lvl").forEach(function (nextLvl) {
                nextLvl.removeAttribute("tabindex");
            });
            parentUl.closest(classNameMobScrollableContainer)?.previousElementSibling?.removeAttribute("tabindex");

            // 本国サイトでjs-clickedクラス付与は利用されていないため、存在しない場合の処理のみ移植
            if (navMobile.querySelectorAll("js-clicked").length === 0) {
                parentUl.querySelectorAll(".js-mobile-flyin").forEach(function (flyin) {                      
                    flyin.removeAttribute("tabindex");
                });
                siblingsLi.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.remove("flyout");
                    }, 40 * index);
                });
                siblingAdditionalMenu?.querySelectorAll("li a").forEach(function (item) {
                    item.removeAttribute("tabindex");
                });
            }

            parentLayer.setAttribute("aria-hidden", "true");
        });
        parentLayer.closest(classNameMobileLayer)?.classList.add("js-visible");
        gradientToggle(classNameMobileLayer, classNameMobScrollableContainer);
    }

    // イニシャライズ
    function headerInit() {
        // モバイル系ヘッダー処理
        mobileHeaderToggle();

        // イベントリスナー登録
        // モバイルグロナビの下階層行きメニュー
        mobileNavNextLvl.forEach(function (item) {
            item.addEventListener("click", function () {
                mobileNextLevel(this)
            });
        })
        // モバイルグロナビの上階層に戻るボタン
        navLayerBack.forEach(function (item) {
            item.addEventListener("click", function () {
                mobileLayerBack(this)
            });
            item.addEventListener("keydown", function (keyInput) {
                if(keyInput.which === 9 && keyInput.shiftKey) {
                    // Shift + Tabキー押下時のFocus処理
                    keyInput.preventDefault();
                    navToggle.focus();
                }
            });
        });

        // PC系ヘッダー処理
        globalHeaderToggle();

        // PCグロナビの第二階層メニュー操作
        navDesktopSubLink.forEach(function (item) {
            item.addEventListener("mouseenter", function () {
                openThirdLayer(this);
            });
            item.addEventListener("keydown", function (keyInput) {
                // .keycodeも.whichも非推奨だが、移植元からひとまず残す
                // Enterキーが押された場合のモーダルを開く処理
                if (keyInput.which === 13) {
                    item.preventDefault();
                    openThirdLayer(this);
                }
            });
        });
        HeaderDrawerEscape();

        /* キー操作系JS：Focus処理用のJSが別途必要なためコメントアウト
        navToggle.addEventListener("keydown", function (keyInput) {
            if(keyInput.which === 9 && keyInput.shiftKey) {
                // Shift + Tabキー押下時のFocus処理
                keyInput.preventDefault();
                if (headerActions.classList.contains("search-expand")) {
                    headerActions.querySelector(".js-search-input-toggle").focus();
                } else {
                    headerActions.querySelector("li:last-child").focus();
                }
            }
        });
        navMobile.querySelectorAll("li:last-child > a").forEach(function (item) {
            item.addEventListener("keydown", function (keyInput) {
                if (keyInput.which !== 9 || keyInput.shiftKey) return;
                keyInput.preventDefault();
                navMobile.querySelector(classNameMobileAdditional).querySelector("li:first-child a").focus();
            });
        });
        navDesktopItemLink.forEach(function (item) { // = m
            item.addEventListener("keydown", function (keyInput) {
                if(keyInput.which === 9 && !keyInput.shiftKey && navDesktop.classList.contains("active") && item.parentElement.matches(":last-child") && !item.classList.contains("selected")) {
                    keyInput.preventDefault();
                    item.closest("ul").querySelector(":focus > .js-desktop-nav-item:first-child:first-child .js-nav-desktop-item-link").focus();
                } else if(keyInput.which === 9 && keyInput.shiftKey && navDesktop.classList.contains("active") && item.parentElement.matches(":first-child")) {
                    keyInput.preventDefault();
                    item.closest("ul").querySelector(":focus > .js-desktop-nav-item:last-child: .js-nav-desktop-item-link").focus();
                }
            });
        });
        document.querySelectorAll(classNameCloseDesktopNav).forEach(function (item) { // = y
            item.addEventListener("keydown", function (keyInput) {
                if(keyInput.which === 9 && !keyInput.shiftKey && item.closest(".js-desktop-nav-item").matches(":last-child")) {
                    keyInput.preventDefault();
                    item.closest(".js-desktop-nav-item").parentElement.querySelector(".js-desktop-nav-item:first-child .js-nav-desktop-item-link").focus()
                }
            });
        });

        document.querySelectorAll(".js-desktop-scrollable-subcontainer li:last-child .js-nav-desktop-tab").forEach(function (item) {
            item.addEventListener("keydown", function (keyInput) {
                keyInput.which !== 9 || keyInput.shiftKey || (
                    keyInput.preventDefault(),
                    item.closest(classNameScrollableParent).querySelector(classNameCloseDesktopSubnav).focus()
                )
            });
        });

        document.querySelectorAll(classNameCloseDesktopSubnav).forEach(function (item) {
            item.addEventListener("keydown", function (keyInput) {
                keyInput.which === 9 && keyInput.shiftKey && (
                    keyInput.preventDefault(),
                    item.parentElement.querySelectorAll(":focus > .js-desktop-scrollable-subcontainer li:last-child .js-nav-desktop-tab").focus()
                )
            });
        });
        */

        navDesktop.querySelectorAll(".js-desktop-scrollable-container").forEach(function (item) {
            item.addEventListener("scroll", function () {
                gradientToggle(classNameDesktopLayer, classNameDesktopScrollableContainer);
            });
        });

        navDesktop.querySelectorAll(".js-desktop-scrollable-subcontainer").forEach(function (item) {
            item.addEventListener("scroll", function () {
                gradientToggle(classNameScrollableParent, ":focus > .js-desktop-scrollable-subcontainer");
            });
        });

        window.addEventListener("resize", function () {
            gradientToggle(classNameScrollableParent, ":focus > .js-desktop-scrollable-subcontainer");
        });
    }

    headerInit();
}



/*=== 実行 ============================================*/
// DOM読み込み完了時に実行
window.addEventListener("DOMContentLoaded", function () {
    globalHeader();
});